import React, { useState, Fragment } from 'react'
import { debounce, compact } from 'lodash'

import { Formik, AutoComplete } from '@components/Form'

const ALLOWED_AUTO_COMPLETE_METHODS = ['click', 'enter', 'type']

const CitySearch = ({ valuationService, setCity, disabled }) => {
  const [suggestions, setSuggestions] = useState([])

  const getCitiesSuggestions = async value => {
    let values = await valuationService.getCities(value)
    setSuggestions(compact(values))
  }

  const debouncedCitiesSuggestions = debounce(getCitiesSuggestions, 500)

  return (
    <Fragment>
      <Formik initialValues={{ citySearch: '' }} onSubmit={() => null}>
        {({ values, setFieldValue }) => (
          <AutoComplete
            noIconSpace
            disabled={disabled}
            autoComplete="off"
            name="citySearch"
            id="citySearchBar"
            value={values.citySearch}
            suggestions={suggestions}
            onSuggestionSelected={(_, { suggestion }) => setCity(suggestion)}
            onChange={(_, { newValue, method }) => {
              if (ALLOWED_AUTO_COMPLETE_METHODS.includes(method)) {
                setFieldValue('citySearch', newValue)
                if (method === 'type' && newValue)
                  debouncedCitiesSuggestions(newValue)
              }
            }}
            placeholder="Busque uma cidade"
          />
        )}
      </Formik>
    </Fragment>
  )
}

export default CitySearch
